import React, { FC } from 'react';
import cx from 'clsx';

import { INVOICE_SUMMARY_SHIMMER_TEST_ID } from './const';

import styles from './styles.module.scss';

const InvoiceSummaryShimmer: FC = () => (
  <section data-testid={INVOICE_SUMMARY_SHIMMER_TEST_ID} className={styles.summary}>
    <h2 className={cx('h6', 'shimmer')} aria-hidden={true} />
    <p className={cx('shimmer')} />

    <h2 className={cx('h6', 'shimmer')} aria-hidden={true} />
    <p className={cx('shimmer')} />

    <h2 className={cx('h6', 'shimmer')} aria-hidden={true} />
    <p className={cx('shimmer', styles.desc1)} />
    <p className={cx('shimmer', styles.desc2)} />
  </section>
);

export { InvoiceSummaryShimmer };
